export const DEFAULT_PAGE_SIZE = 5;

// Backend-enforced hard limits for VM resource configuration.
// These match the validation ceilings the API applies on POST /vmTemplate.
// If the backend ever raises these limits, update here only.
export const VM_CPU_CORE_MAX = 20;
export const VM_STORAGE_MAX_GB = 250;
